import axios from "axios";
export async function requestAssignmentCancellation(assignmentId) {
    await axios.post(`/api/workflow/assignment/${assignmentId}/requestCancel`);
}
export async function getMyAssignmentsInProgress() {
    const requester = await axios.get('/api/workflow/requester/inProgress');
    return requester.data;
}
